import Filters from "./components/Filters"
import StatusDashboard from "./StatusDashboard"
import TicketsDashboardProvider from "./TIcketsDashboardContext"
import AssigneeDashboard from "./AssigneeDashboard"
import { Grid } from "@material-ui/core"


let index = () => {
    return (
        <TicketsDashboardProvider>
            <Filters />
            <Grid container>
                <Grid item xs><StatusDashboard /></Grid>
                <Grid item xs><AssigneeDashboard /></Grid>
            </Grid>
        </TicketsDashboardProvider>
    )
}
export default index